import { ProductError } from "../../Types/Product/ProductError";
import { ProductValueType } from "../../Types/Product/ProductValueType";
import { ProductWarning } from "../../Types/Product/ProductWarning";

export interface IInitialStateProduct {
  values: ProductValueType;
  errors: ProductError;
  warnings: ProductWarning;
  submitted: boolean;
  dirty: boolean;
  setPopup: boolean;
}

export const iInitialStateProduct: IInitialStateProduct = {
  values: {
    newLine: undefined,
    sainId: undefined,
    skuNumber: undefined,
    catNumber: undefined,
    depotId: undefined,
    unitOfMeasure: undefined,
    description: undefined,
    packSize: undefined,
    outerLength: undefined,
    outerWidth: undefined,
    outerHeight: undefined,
    outerWeight: undefined,
    outerNetWeight: undefined,
    innerLength: undefined,
    innerWidth: undefined,
    innerHeight: undefined,
    innerWeight: undefined,
    innerNetWeight: undefined,
    ti: undefined,
    hi: undefined,
    merchandisingUnit: undefined,
    conveyable: undefined,
    twoPersonLift: undefined,
    uglies: undefined,
    ean: undefined,
    minimumLifeOnReceipt: undefined,
    minimumLifeOnIssue: undefined,
    breakPack: undefined,
    hazardous: undefined,
    hazardousCode: undefined,
    multiPart: undefined,
    productType: undefined,
    familyGroup: undefined,
    lifecycle: undefined,
    activeDate: undefined,
    nestedItem: undefined,
    nestIncrement: undefined,
    grabInBox: undefined,
    measurementRequired: undefined,
    validation: undefined,
    company: undefined,
    businessUnit: undefined,
    businessUnitDesc: undefined,
    superCategory: undefined,
    category: undefined,
    categoryDesc: undefined,
    subCategory: undefined,
    subCategoryDesc: undefined,
    superCatDesc: undefined,
    segment: undefined,
    segmentDesc: undefined,
    skuCount: undefined,
    mlor: undefined,
    mloi: undefined,
    error: undefined,
    oldFamilyGroup: undefined,
    warehouseId: undefined,
    id: "",
    createdDate: undefined,
    updatedDate: undefined,
    familyGroupWithDescription: undefined,
    outerDimensions: undefined,
    innerDimensions: undefined,
    automationAdaptoSystem: undefined,
    automationToteFill: undefined,
    automationMinTotes: undefined,
    highRisk: undefined,
    strapTotes: undefined,
    expiryDateRequired: undefined,
    pickPack: undefined,
  },
  errors: {
    newLine: undefined,
    sainId: undefined,
    skuNumber: undefined,
    catNumber: undefined,
    unitOfMeasure: undefined,
    description: undefined,
    packSize: undefined,
    outerLength: undefined,
    outerWidth: undefined,
    outerHeight: undefined,
    outerWeight: undefined,
    outerNetWeight: undefined,
    innerLength: undefined,
    innerWidth: undefined,
    innerHeight: undefined,
    innerWeight: undefined,
    innerNetWeight: undefined,
    ti: undefined,
    hi: undefined,
    merchandisingUnit: undefined,
    conveyable: undefined,
    twoPersonLift: undefined,
    uglies: undefined,
    ean: undefined,
    minimumLifeOnReceipt: undefined,
    minimumLifeOnIssue: undefined,
    breakPack: undefined,
    hazardous: undefined,
    hazardousCode: undefined,
    multiPart: undefined,
    productType: undefined,
    familyGroup: undefined,
    lifecycle: undefined,
    activeDate: undefined,
    nestedItem: undefined,
    nestIncrement: undefined,
    grabInBox: undefined,
    measurementRequired: undefined,
    validation: undefined,
    company: undefined,
    businessUnit: undefined,
    businessUnitDesc: undefined,
    superCategory: undefined,
    category: undefined,
    categoryDesc: undefined,
    subCategory: undefined,
    subCategoryDesc: undefined,
    superCatDesc: undefined,
    segment: undefined,
    segmentDesc: undefined,
    skuCount: undefined,
    mlor: undefined,
    mloi: undefined,
    error: undefined,
    oldFamilyGroup: undefined,
    warehouseId: undefined,
    id: "",
    createdDate: undefined,
    updatedDate: undefined,
    familyGroupWithDescription: undefined,
    automationAdaptoSystem: undefined,
    automationToteFill: undefined,
    automationMinTotes: undefined,
    highRisk: undefined,
    strapTotes: undefined,
    expiryDateRequired: undefined,
    pickPack: undefined,
    outerDimensions: {},
    innerDimensions: {},
  },
  warnings: {
    newLine: undefined,
    sainId: undefined,
    skuNumber: undefined,
    catNumber: undefined,
    unitOfMeasure: undefined,
    description: undefined,
    packSize: undefined,
    outerLength: undefined,
    outerWidth: undefined,
    outerHeight: undefined,
    outerWeight: undefined,
    outerNetWeight: undefined,
    innerLength: undefined,
    innerWidth: undefined,
    innerHeight: undefined,
    innerWeight: undefined,
    innerNetWeight: undefined,
    ti: undefined,
    hi: undefined,
    merchandisingUnit: undefined,
    conveyable: undefined,
    twoPersonLift: undefined,
    uglies: undefined,
    ean: undefined,
    minimumLifeOnReceipt: undefined,
    minimumLifeOnIssue: undefined,
    breakPack: undefined,
    hazardous: undefined,
    hazardousCode: undefined,
    multiPart: undefined,
    productType: undefined,
    familyGroup: undefined,
    lifecycle: undefined,
    activeDate: undefined,
    nestedItem: undefined,
    nestIncrement: undefined,
    grabInBox: undefined,
    measurementRequired: undefined,
    validation: undefined,
    company: undefined,
    businessUnit: undefined,
    businessUnitDesc: undefined,
    superCategory: undefined,
    category: undefined,
    categoryDesc: undefined,
    subCategory: undefined,
    subCategoryDesc: undefined,
    superCatDesc: undefined,
    segment: undefined,
    segmentDesc: undefined,
    skuCount: undefined,
    mlor: undefined,
    mloi: undefined,
    oldFamilyGroup: undefined,
    warehouseId: undefined,
    id: "",
    createdDate: undefined,
    updatedDate: undefined,
    familyGroupWithDescription: undefined,
    automationAdaptoSystem: undefined,
    automationToteFill: undefined,
    automationMinTotes: undefined,
    highRisk: undefined,
    strapTotes: undefined,
    expiryDateRequired: undefined,
    pickPack: undefined,
    outerDimensions: {},
    innerDimensions: {},
  },
  submitted: false,
  dirty: false,
  setPopup: false,
};

export interface IProductFieldProps {
  closeModal: () => void;
  isEdit: boolean;
}
